import { ReactNode } from 'react';
import { CloseIcon } from '@/assets/icons/CloseIcon';
import { Text } from '../Text/Text';
import styles from './transcript.module.scss';

export interface TranscriptProps {
    transcript: ReactNode;
    closeHandler?: () => void;
    classNames?: string;
}

export function Transcript({ transcript, closeHandler, classNames }: TranscriptProps) {
    return (
        <div className={classNames}>
            <div className={styles.closeIconBar}>
                <Text tag="h6" variant="h6" className={styles.transcriptHeader}>
                    Transcript
                </Text>
                <button onClick={closeHandler}>
                    <CloseIcon />
                </button>
            </div>
            <ul className={styles.transcriptText}>{transcript}</ul>
        </div>
    );
}
